var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-loader",class:[_vm.isLoading && 'global-loader--loading']},[_c('div',{staticClass:"global-loader__loader"},[_c('InlineSvg',{attrs:{"src":require('@/assets/img/VVV-logo.svg'),"width":"64","height":"58"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }